import { useTranslation } from "react-i18next";

import { NothingConfigured, Typography } from "@digital-services/ui";

import BigKeyIcon from "@icons/key_96.svg?react";

import { CreateApiUserButton } from "./CreateApiUserButton";

interface Props {
  message1?: string;
  message2?: string;
}

export function NoApiUsersConfigured(props: Readonly<Props>) {
  const { t: tApiUserTab } = useTranslation(undefined, {
    keyPrefix: "api-users"
  });

  const msg1 = props.message1 || tApiUserTab("messages.users-no-data-1");
  const msg2 = props.message2 || tApiUserTab("messages.users-no-data-2");

  return (
    <NothingConfigured
      title={msg1}
      icon={<BigKeyIcon />}
      actionButton={
        <div className="mt-8">
          <CreateApiUserButton />
        </div>
      }
    >
      <Typography className="max-w-[260px] text-center" variant="description">
        {msg2}
      </Typography>
    </NothingConfigured>
  );
}
